export const ADD_SEARCHED: string = "add_searched";
